import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import {
  HomeIcon,
  CalendarIcon,
  PlusCircleIcon,
  ChatBubbleLeftRightIcon,
  EllipsisHorizontalCircleIcon,
} from '@heroicons/react/24/outline';
import {
  EVENTS_ROUTE,
  CALENDAR_ROUTE,
  CREATE_EVENT_ROUTE,
  CHATS_ROUTE,
  EXTRA_ROUTE,
} from '../routes';

const BottomNavBar: React.FC = () => {
  const location = useLocation();

  const navItems = [
    { to: EVENTS_ROUTE, icon: HomeIcon, label: 'Eventi' },
    { to: CALENDAR_ROUTE, icon: CalendarIcon, label: 'Calendario' },
    { to: CREATE_EVENT_ROUTE, icon: PlusCircleIcon, label: 'Crea', prominent: true },
    { to: CHATS_ROUTE, icon: ChatBubbleLeftRightIcon, label: 'Chat' },
    { to: EXTRA_ROUTE, icon: EllipsisHorizontalCircleIcon, label: 'Extra' },
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white md:hidden z-50" style={{ transition: 'transform 0.3s ease-in-out', boxShadow: '0 -2px 10px rgba(0, 0, 0, 0.1)' }}>
      <div className="flex justify-around items-center h-16">
        {navItems.map((item) => {
          const isActive = location.pathname === item.to;
          const Icon = item.icon;

          if (item.prominent) {
            return (
              <NavLink key={item.label} to={item.to} className="flex-1 flex flex-col items-center justify-center -mt-4">
                <div className={`rounded-full p-2 ${isActive ? 'bg-indigo-600' : 'bg-indigo-500'}`}>
                  <Icon className={`h-8 w-8 text-white`} />
                </div>
                <span className={`text-xs mt-1 ${isActive ? 'text-indigo-600' : 'text-gray-500'}`}>{item.label}</span>
              </NavLink>
            );
          }

          return (
            <NavLink key={item.label} to={item.to} className="flex-1 flex flex-col items-center justify-center">
              <Icon className={`h-6 w-6 ${isActive ? 'text-indigo-600' : 'text-gray-500'}`} />
              <span className={`text-xs mt-1 ${isActive ? 'text-indigo-600' : 'text-gray-500'}`}>{item.label}</span>
            </NavLink>
          );
        })}
      </div>
    </div>
  );
};

export default BottomNavBar;
